import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

const useStyles = makeStyles((theme) => ({
    institutionFieldControlDesk: {
      minWidth: 320,
      marginRight: 24
    },
    fieldControlMD: {
        width: '100%'
    },
    headerText: {
        fontSize: '1.25rem'
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

const SelectTestFieldsBlock = styled.div`
    margin-top: 8px;
    display: flex;
    flex-direction: column
`

const FiltrosSimulado = ({ data }) => {
    const classes = useStyles();
    const [simulatedList, setSimulatedList] = useState([])
    const [result, setResult] = useState('none')

    const handleChange = (event) => {
        setResult(event.target.value);
    };

    useEffect(() => {
        setSimulatedList((data||{}).simulados || [])
    }, []) // eslint-disable-line

    return <>
        {simulatedList !== undefined ? <SelectTestFieldsBlock> 
                <Typography gutterBottom variant="body1" component="p" className={classes.headerText}>
                    Selecione um simulado:
                </Typography>
                <FormControl component="fieldset">
                    <RadioGroup aria-label="gender" name="gender1" onChange={handleChange}>
                        {(simulatedList || []).map(item => <FormControlLabel value={item._id} control={<Radio />} label={(item.instituicao || {}).nome} />)}
                    </RadioGroup>
                </FormControl>
                <Link component={RouterLink} to="" className={classes.menuLink}>
                    <Button disabled={result === 'none'} component={RouterLink} to={`/simulado/${result || {}}`} variant="contained" color="primary" style={{ width: 'auto' }} endIcon={<ArrowForwardIosIcon style={{ fontSize: '16px' }} />}>Iniciar</Button>
                </Link>
            </SelectTestFieldsBlock> : ''
        }
    </>
}

export default FiltrosSimulado